import React, { useEffect, useState } from 'react';
import moment from 'moment';
import truncate from 'truncate';
import { Link as ReachLink } from 'react-router-dom';

import ActivityProgressBar from '../Farm/ActivityProgressBar';
import { Flex, Box, Avatar, Heading, Link, Image, Text } from '@chakra-ui/core';

const FarmCard = ({ data, setSession, setUnexpectedError, fetchActivities }) => {
  const { _id, name, product, acreage, status } = data;
  const { crop, location, manager, message, duration, startDate, updatedAt } = product;

  const [activities, setActivities] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const activities = await fetchActivities(_id, product._id);
        if (activities.code === 200) {
          if (mounted) setActivities(activities.data);
        } else setUnexpectedError('Unexpected Server Error!');
      } catch (error) {
        if (error.status === 401) setSession(false);
        else setUnexpectedError('Unexpected Network Error!');
      }
    })();
    return () => (mounted = false);
  }, [_id, fetchActivities, product._id, setSession, setUnexpectedError]);

  return (
    <Link
      as={ReachLink}
      to={{
        pathname: `/farms/${_id}`,
        state: { activities, data }
      }}
      bg="white"
      shadow="lg"
      _hover={{ textDecor: 'none', color: 'black' }}
      w={{ base: '100%', md: 85, lg: 120 }}
      py={5}
      mt={5}
      rounded="sm"
    >
      <Flex wrap="wrap" align="center">
        <Box w="100%" px={{ base: 3, md: 6 }}>
          <Flex wra="wrap">
            <Avatar src={crop.imageUrl} alt={crop.name} backgroundColor="white" />

            <Box ml={4}>
              <Heading as="h6">
                {name} | {acreage} Acre(s)
              </Heading>
              <p className="text-xs md:text-sm lg:text-base">
                {location.name}, {location.state}
              </p>
            </Box>
          </Flex>
          <ActivityProgressBar
            farmId={_id}
            activities={activities}
            duration={duration}
            startDate={startDate}
            status={status}
          />
        </Box>

        <Box className="w-full my-2">
          <Image src={crop.imageUrl} alt={crop.name} />
        </Box>

        <Box px={8} my={6}>
          <Flex>
            <Box d={{ base: 'none', md: 'block' }}>
              <Avatar
                src={manager.photoUrl}
                alt={[manager.firstName, manager.lastName].join(' ')}
              />
            </Box>
            <Box ml={{ base: 2, md: 6 }} w={{ md: '100%' }}>
              <Heading as="h6" borderBottomWidth={1} borderBottomColor="cf.400" pb={2}>
                Farm Manager latest update
              </Heading>
              {message && (
                <Text as="span" fontSize="tiny" fontWeight="bold">
                  {moment(updatedAt).fromNow()}
                </Text>
              )}
              <Text fontSize={{ base: 'tiny', md: 'sm', lg: 12 }} className="mt-1">
                {(message && (
                  <>
                    {truncate(message, 150)}
                    <span className="text-cf-300">more</span>
                  </>
                )) ||
                  'No update from me yet!'}
              </Text>
            </Box>
          </Flex>
        </Box>
      </Flex>
    </Link>
  );
};

export default FarmCard;
